/* ════ DOM HELPERS ═════════════════════════════════════════ */
export const $ = id => document.getElementById(id);
export const $$ = sel => document.querySelectorAll(sel);
